// components/PrivateRoute.jsx
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Preloader from "../../../components/Preloader";

const PrivateRoute = ({ children }) => {
  const { user, token, loading } = useSelector((state) => state?.userAuth || {});
  const location = useLocation();
  const navigate = useNavigate();
  const isNavigatingRef = React.useRef(false);

  useEffect(() => {
    if (isNavigatingRef.current) return;
    
    if (loading) return;
    
    if (!user || !token) {
      isNavigatingRef.current = true;
      navigate("/login", { replace: true, state: { from: location } });
      return () => {
        isNavigatingRef.current = false;
      };
    }
    isNavigatingRef.current = false;
  }, [user, token, loading, location, navigate]);

  if (loading) {
    return <Preloader variant="inline" containerClassName="min-h-[40vh]" />;
  }

  if (!user || !token) {
    return null;
  }

  return children;
};

export default PrivateRoute;
